<template>
    <div>
        <base-loading :visible="isLoading" />
        <edit-expense :isOpen="editSidebar" @close="editSidebar = false" :itemId="selectedItem" @update="doSearch"/>
        <pdf-viewer :isOpen="showPdf" :pdfUrl="pdfUrl" @close="showPdf = false" />
        <confirmation-modal 
            :isOpen="confirmationApprove" 
            @close="confirmationApprove = false" 
            @accept="approveExpense"
            :message="$t('confirm_approval')"
            :item="{id:selectedItem}" />
         <confirmation-modal 
            :isOpen="confirmationDelete" 
            @close="confirmationDelete = false" 
            @accept="deleteExpense"
            :message="$t('confirm_deletion')"
            :item="{id:selectedItem}" />
        <vs-row vs-type="flex" vs-justify="flex-end">
            <vs-col vs-lg="8" vs-sm="5" vs-xs="0">
            </vs-col>
            <vs-col vs-lg="2" vs-sm="4" vs-xs="12" class="p-1">
                <search-input v-model="search" @handleSearch="doSearch" />
            </vs-col>
            <!-- <vs-col vs-lg="1" vs-sm="4" vs-xs="12" class="p-1">
                <expense-filter :clientList="clientList" :filters="filters" @update:filters="filters = $event"
                    @apply-filters="doSearch" />
            </vs-col> -->
        </vs-row>
        <vs-row>
            <vs-col>
                <expense-table :items="items" 
                    @loadMore="loadMore()"
                    @edit="handleEdit" 
                    @delete="handleDelete" 
                    @approve="handleApprove"
                    @showFile="handleShowFile" 
                    />
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import ExpenseTable from './components/ExpenseTable.vue'
import SearchInput from '@/views/app/components/inputs/SearchInput.vue'
import request from './request'
import EditExpense from './components/EditExpense.vue'
import ExpenseFilter from './components/ExpenseFilter.vue'
import ConfirmationModal from '@/views/app/components/modals/ConfirmationModal.vue'
import PdfViewer from '@/views/app/components/modals/PdfViewer.vue'
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';
export default {
    components: { ExpenseTable, SearchInput, EditExpense, ExpenseFilter, ConfirmationModal, PdfViewer,BaseLoading },
    data() {
        return {
            editSidebar: false,
            confirmationApprove: false,
            confirmationDelete: false,
            showPdf:false,
            pdfUrl:'',
            selectedItem: '',
            items: [],
            search: '',
            //filters: { client: null },
            clientList: [],
            page: 1,
            lastPage: 1,
            loading:{
                list:false,
                submit:false,
                file:false
            }
        }
    },
    computed: {
        isLoading(){
            return this.loading.list || this.loading.submit | this.loading.file
        }
    },

    methods: {
        handleEdit(row) {
            this.editSidebar = true
            this.selectedItem = row.id
        },

        handleDelete(row) {
            this.confirmationDelete = true
            this.selectedItem = row.id
        },

        handleApprove(row) {
            this.confirmationApprove = true
            this.selectedItem = row.id
        },

        doSearch() {
            this.page = 1
            this.getList()
        },

        getList() {
            const payload = {
                search: this.search,
                page: this.page
            }
            this.loading.list = true
            request.getList(payload)
                .then(response => {
                    if (this.page === 1) {
                        this.items = [...response.data.data]
                    } else {
                        this.items = [...this.items, ...response.data.data]
                    }
                    this.lastPage = response.data.last_page
                    this.page = response.data.current_page
                    this.loading.list = false
                })
                .catch(response => {
                    this.loading.list = false
                    //console.log(response)
                })
        },

        loadMore() {
            if (this.page >= this.lastPage) {
                return
            }
            this.page++
            this.getList()
        },



        approveExpense(item) {
            this.confirmationApprove = false
            const payload = {
                id: item.id
            }
            this.loading.submit = true
            request.approveExpense(payload)
                .then(response => {
                    this.loading.submit = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Approved',
                    })
                    this.getList()
                })
                .catch(response => {
                    this.loading.submit = false
                    //console.log(response)
                })
        },

        deleteExpense(item) {
            this.confirmationDelete = false
            const payload = {
                id: item.id
            }
            this.loading.submit = true
            request.deleteExpense(payload)
                .then(response => {
                    this.loading.submit = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Deleted',
                    })
                    this.getList()
                })
                .catch(response => {
                    this.loading.submit = false
                    //console.log(response)
                })
        },

        handleShowFile(row){
             const payload = {
                id: row.id
            }
            this.loading.file = true
            request.getFiles(payload)
                .then(response => {
                    this.loading.file = false
                    this.pdfUrl = response.data.file[0].src
                    //console.log(this.pdfUrl)
                    this.showPdf = true
                })
                .catch(response => {
                    this.loading.file = false
                    //console.log(response)
                })
        }
    },

    mounted() {
        this.getList()
    }
}
</script>

<style></style>